<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการคำร้องของผู้ให้บริการอินเทอร์เน็ตความเร็วสูงประจำที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการคำร้องของผู้ให้บริการอินเทอร์เน็ตความเร็วสูงประจำที่
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ผู้ให้บริการ" prop="networkName">
                            <el-select filterable v-model="form.provider_id">
                              <el-option :value="null" label="ทั้งหมด"></el-option>
                              <el-option
                                  v-for="item in provider"
                                  :key="item.id"
                                  :label="item.provider_name"
                                  :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="สถานะการดำเนินการ">
                            <el-checkbox-group v-model="form.cr_status">
                              <el-checkbox v-for="(item,index) in cr_option" :key="index" :label="index">{{item}}</el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ช่วงเวลาในการค้นหา">
                            <el-date-picker
                              v-model="form.daterange"
                              type="daterange"
                              align="right"
                              unlink-panels
                              range-separator="ถึง"
                              start-placeholder="วันเริ่มต้น"
                              end-placeholder="วันสิ้นสุด"
                              :picker-options="pickerOptions">
                            </el-date-picker>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="searching()">
                          ค้นหา
                        </button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="box-body">
                  <data-tables-server
                    @query-change="searching"
                    :loading="loading"
                    :data="data_table"
                    :total="total"
                    :page-size="form.pageSize"
                    :current-page.sync="form.page"
                    :pagination-props="{
                      background: true,
                      pageSizes: [10, 20, 50]
                    }"
                    :table-props="tableProps"
                  >
                    <el-table-column sortable prop="cr_status" label="สถานะการดำเนินการ" >
                      <template slot-scope="item">
                        {{ cr_option[item.row.cr_status] }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="promotion_code" label="รหัสรายการส่งเสริมการขาย" ></el-table-column>
                    <el-table-column sortable prop="promotion_name_th" label="ชื่อรายการส่งเสริมการขาย" ></el-table-column>
                    <el-table-column sortable prop="created_at" label="วันที่ดำเนินการ" ></el-table-column>
                    <el-table-column
                      label="จัดการ"
                      align="center"
                      fixed="right"
                      width="170"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top" :enterable="false">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="success"
                            @click="handleView(scope.row)"
                          >
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ยืนยัน" placement="top" :enterable="false">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="primary"
                            @click="handleEdit(scope.row,'approve')"
                            :disabled="!(scope.row.cr_status == 'request' || scope.row.cr_status == 'waiting')"
                          >
                            <i class="el-icon-check"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ปฏิเสธ" placement="top" :enterable="false">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="danger"
                            @click="handleEdit(scope.row,'reject')"
                            :disabled="!(scope.row.cr_status == 'request' || scope.row.cr_status == 'waiting')"
                          >
                            <i class="el-icon-close"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                    <el-dialog title="รายละเอียดการร้องขอแก้ไขข้อมูล" :visible.sync="dialogViewVisible" :width="'75%'">
                      <el-form v-model="dialogData" :label-position="'top'">
                        <el-form-item label="ตารางแสดงการเปลี่ยนแปลงข้อมูล" v-if="['approve_edit','reject_edit'].includes(dialogForm.cr_status)">
                          <el-table :data="compare_table" border >
                            <el-table-column prop="name" label="หัวข้อที่แก้ไข"></el-table-column>
                            <el-table-column prop="old" label="ข้อมูลเก่า"></el-table-column>
                            <el-table-column prop="new" label="ข้อมูลใหม่"></el-table-column>
                          </el-table>
                        </el-form-item>
                        <el-form-item label="รหัสรายการส่งเสริมการขาย">
                          {{dialogData.promotion_code}}
                        </el-form-item>
                        <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                          {{dialogData.promotion_name_th}}
                        </el-form-item>
                        <el-form-item label="ชื่อผู้ดำเนินการ">
                          {{dialogData.oper_name}}
                        </el-form-item>
                        <el-form-item label="ผู้ให้บริการ">
                          {{dialogData.provider_name+' ('+dialogData.brand_name_th+') ' || '-'}}
                        </el-form-item>
                        <el-form-item label="เจ้าหน้าที่ผู้ดูแลระบบ">
                          {{dialogData.admin_name || '-'}}
                        </el-form-item>
                        <el-form-item label="ข้อความ">
                          {{dialogData.cr_remark || '-'}}
                        </el-form-item>
                        <el-form-item label="วันที่ดำเนินการ">
                          {{dialogData.created_at}}
                        </el-form-item>
                      </el-form>
                    </el-dialog>
                    <el-dialog title="จัดการการร้องขอแก้ไขข้อมูล" :visible.sync="dialogFormVisible">
                      <el-form :model="dialogForm" :label-position="'top'">
                        <el-form-item label="ตารางแสดงการเปลี่ยนแปลงข้อมูล"  v-if="['approve_edit','reject_edit'].includes(dialogForm.cr_status)">
                          <el-table :data="compare_table" border >
                            <el-table-column prop="name" label="หัวข้อที่แก้ไข"></el-table-column>
                            <el-table-column prop="old" label="ข้อมูลเก่า"></el-table-column>
                            <el-table-column prop="new" label="ข้อมูลใหม่"></el-table-column>
                          </el-table>
                        </el-form-item>
                        <el-form-item label="รหัสรายการส่งเสริมการขาย">
                          {{ dialogForm.promotion_code }}
                        </el-form-item>
                        <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                          {{ dialogForm.promotion_name_th }}
                        </el-form-item>
                        <el-form-item label="จัดการ">
                            {{ cr_option[dialogForm.cr_status] }}
                        </el-form-item>
                        <el-form-item label="ข้อความ">
                          <el-input v-model="dialogForm.cr_remark" type="textarea" :rows="3" show-word-limit maxlength="250"></el-input>
                        </el-form-item>
                      </el-form>
                      <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">ปิดหน้าต่าง</el-button>
                        <el-button type="primary" @click="submit()">ตกลง</el-button>
                      </span>
                    </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
  import { mapState, mapActions } from "vuex"
  export default {
    data() {
      return {
        dialogViewVisible: false,
        dialogFormVisible: false,
        dialogData: {},
        dialogForm: {},
        label_position: "top",
        form: {
          page: 1,
          pageSize: 10,
          provider_id: null,
          cr_status: ['request','approve_request','waiting'],
          sort: null,
          daterange: []
        },
        tableProps: {
          border: false,
          stripe: true
        },
        pickerOptions: {
          shortcuts: [{
            text: 'สัปดาห์ล่าสุด',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'เดือนล่าสุด',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '3 เดือนล่าสุด',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      };
    },
    computed: {
      ...mapState({
        provider: store => store.Manage_request.provider,
        data_table: store => store.Manage_request.data_table,
        loading: store => store.Manage_request.loading,
        total: store => store.Manage_request.total,
        cr_option: store => store.Manage_request.cr_status_th,
        compare_table: store => store.Manage_request.compare_table_data
      })
    },
    mounted() {
      this.getProvider('broadband')
    },
    methods: {
      ...mapActions({
        getProvider : 'Manage_request/getProviderList',
        getBroadbandRequest : 'Manage_request/getBroadbandRequest',
        setRequestStatus : 'Manage_request/setBroadbandRequestStatus',
        getBroadbandEditRevision : 'Manage_request/getBroadbandEditRevision'
      }),
      searching(queryInfo){
        this.form.page = queryInfo ? queryInfo.page : 1
        this.form.pageSize = queryInfo ? queryInfo.pageSize : 10
        this.form.sort = queryInfo ? queryInfo.sort : null
        this.getBroadbandRequest(this.form)
      },
      handleView(row){
        this.dialogForm = {}
        this.dialogData = row
        this.dialogViewVisible = true
      },
      handleEdit(row,status){
        let mark_status = ''
        if(row.cr_status == 'request'){
          mark_status  = status == 'approve' ? 'approve_request' : 'reject_request'
        }else if(row.cr_status == 'waiting' || row.cr_status == 'approve_edit'){
          this.getBroadbandEditRevision(row.promotion_id);
          mark_status = status == 'approve' ? 'approve_edit' : 'reject_edit'
        }
        this.dialogFormVisible = true
        this.dialogForm = Object.assign({},row)
        this.dialogForm.cr_status = mark_status
        this.dialogForm.cr_remark = ''
      },
      submit(){
        this.dialogFormVisible = false
        this.dialogForm.provider_type = 'broadband'
        var formdata = {}
            formdata.dialogForm = this.dialogForm
            formdata.filterForm = this.form
        this.setRequestStatus(formdata)
      }
    }
  };
</script>
<style lang="stylus" scoped>

</style>